import { PropsWithChildren, Children, FC, useRef, ReactNode } from "react";
import { DateTimeIcon, DownIcon, MoreIcon, TimeIcon } from "@components/icons";
import { Menu, MenuItem, ClickEvent } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { Button } from "@components/button";
import "./action.scss";

export type ActionVarient = "select" | "date-picker" | "time-picker";

interface ActionProps extends PropsWithChildren {
  className?: string;
  mode?: ActionVarient;
  label?: ReactNode;
  keepOpenOnClick?: boolean;
  handleItemClick?: (event: ClickEvent) => void;
  disabled?: boolean;
  containerClassName?: string;
  zIndex?: string;
  portal?: boolean;
  menuItemClassName?: string;
}

export const Action: FC<ActionProps> = ({
  className = "",
  children,
  mode,
  label,
  handleItemClick,
  disabled,
  keepOpenOnClick,
  containerClassName,
  zIndex,
  portal,
  menuItemClassName = "",
}) => {
  const ddlBox = useRef<HTMLButtonElement>(null);

  return (
    <Menu
      portal={!!portal}
      onItemClick={(e) => {
        handleItemClick;
        e.keepOpen = keepOpenOnClick;
      }}
      menuClassName={`${containerClassName} ${mode}`}
      menuStyle={{
        width: mode === "select" ? ddlBox.current?.getBoundingClientRect().width : "",
        zIndex: zIndex,
      }}
      menuButton={
        <Button className={`${className} action-mode ${mode}`} ref={ddlBox} disabled={!!disabled}>
          {label ? label : <MoreIcon />}
          {mode && (
            <span className="arrow-down">
              {mode === "select" && <DownIcon size="12" />}
              {mode === "date-picker" && <DateTimeIcon />}
              {mode === "time-picker" && <TimeIcon />}
            </span>
          )}
        </Button>
      }
    >
      {Children.map(children, (child, index) => {
        return (
          <MenuItem key={index} className={menuItemClassName}>
            {child}
          </MenuItem>
        );
      })}
    </Menu>
  );
};
